export default "__VITE_ASSET__67d11dc7__"